import { render, staticRenderFns } from "./Telemarketing.vue?vue&type=template&id=4987d826&scoped=true"
import script from "./Telemarketing.vue?vue&type=script&lang=ts"
export * from "./Telemarketing.vue?vue&type=script&lang=ts"
import style0 from "./Telemarketing.vue?vue&type=style&index=0&id=4987d826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987d826",
  null
  
)

export default component.exports